// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1N6MD","auth-panel":"styles_auth-panel__3D3Ct","auth-panel-title":"styles_auth-panel-title__3tsl-"};